<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container cont-bdr mb-5">
          <!-- row starts -->
          <div class="row">
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-12 col-bdr-bottom">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Report Title</strong>
                </span>
                <span class="float-right">
                  <strong>Event Code :</strong> T327
                </span>
              </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
              <img :src="basepath+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Plot # 5-11, Diplomatic Enclave, G-5, P.O.BOX 1051, Islamabad 44000, Pakistan</strong>
                </span>
              </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-4 col-bdr-bottom">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Country Office Pakistan</strong>
                </span>
              </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
            <!-- col-md starts -->
            <div class="col-md-12 col-bdr-bottom">
              <p class="mt-2 mb-2">
                <span>
                  <strong>Name of Event :</strong> Training on "Administrative Management, Managing Audit and Accounts"
                </span>
              </p>
            </div>
            <!-- col-md ends -->
            <!-- ----------------------------------- -->
          </div>
          <!-- row ends -->
        </div>
        <div class="container-fluid mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Advisor/advisordashboard'
                    },
                    {
                      title: 'Thematic Area Report',
                      url: '#',
                      active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="heading mt-3">
              <h3 class="text-secondary">
                Thematic Area Report
                <span
                  class="btn btn-primary float-right btn-sm print-btn"
                  @click="printInvoice"
                >
                  <i class="material-icons">print</i> Print
                </span>
              </h3>
            </div>
            <div v-for="(item,index) in thematicArr" :key="index">
              <div class="form-group form-row text-dark">
                <h6 class="sub-frm-title">{{item.name}}</h6>
                <div class="row col-sm-12" v-if="item.isData == true">
                  <div class="row col-sm-12">
                    <label
                      class="col-sm-2 font-weight-bold"
                      style="padding:0px 0px 0px 15px"
                    >Country:</label>
                    <p class="col-sm-2" style="padding:0px 0px 0px 15px">Pakistan</p>

                    <label class="col-sm-2 font-weight-bold p-0">No. of Program Officer:</label>
                    <p class="col-sm-2 p-0">{{item.officer}}</p>

                    <label class="col-sm-2 font-weight-bold p-0">No. of Advisor:</label>
                    <p class="col-sm-2 p-0">{{item.advisor}}</p>
                  </div>
                  <div class="row col-sm-12">
                    <label
                      class="col-sm-2 font-weight-bold"
                      style="padding:0px 0px 0px 15px"
                    >No. of Trainees (Participants)</label>
                    <p class="col-sm-2" style="padding:0px 0px 0px 15px">
                      <router-link
                        to="/dashboard/Advisor/trainingReportAdvisor"
                        class="linked"
                      >{{item.trainee}}</router-link>
                    </p>
                    <label class="col-sm-2 font-weight-bold p-0">No. of Trainings</label>
                    <p class="col-sm-2 p-0">
                      <!-- <router-link to="trainingReportList">{{item.trainings}}</router-link> -->
                      <router-link
                        to="/dashboard/Advisor/trainingReportListAdvisor?thematicId=1"
                        class="linked"
                      >{{item.trainings}}</router-link>
                    </p>
                  </div>
                </div>
                <div class="row col-sm-12" v-else>
                  <p class="ml-3">No Trainings Found</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./thematicFilter";
import axios from "axios";


export default {
  data: () => ({
    isSidebar: false,
    thematicArr: [],
    thematicIndex: []
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/thematic/get/all/"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        response.data.map(val => {
          this.openLoading();
          axios
            .get(localStorage.getItem("BASE_PATH") + "/thematic/get/")
            .then(res => {
              res.data.map((training, index) => {
                if (
                  training.trainer.thematic_id &&
                  training.trainer.thematic_id.includes(val.id)
                ) {
                  if (this.thematicArr.some(person => person.id === val.id)) {
                    this.thematicIndex = this.thematicArr
                      .map(e => e.id)
                      .indexOf(val.id);
                    this.thematicArr[this.thematicIndex].trainee +=
                      training.traineeCount;
                    this.thematicArr[this.thematicIndex].officer += 1;
                    this.thematicArr[this.thematicIndex].advisor += 1;
                    this.thematicArr[this.thematicIndex].trainings += 1;
                  } else {
                    this.thematicArr.push({
                      isData: true,
                      id: val.id,
                      name: val.name,
                      trainee: training.traineeCount,
                      officer: index + 1,
                      advisor: index + 1,
                      trainings: index + 1
                    });
                  }
                } else {
                  if (!this.thematicArr.some(person => person.id === val.id)) {
                    this.thematicArr.push({
                      isData: false,
                      id: val.id,
                      name: val.name
                    });
                  }
                }
              });
              this.closeLoading();
            });
        });
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
       
      this.$vs.loading.close();
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    formSubmitted() {
      alert("Form submitted!");
    },
    next: function() {
      if (this.currentQ + 1 < this.questions.length) {
        this.currentQ++;
      }
    },
    printInvoice: function() {
      window.print();
    }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
li {
  list-style-type: none !important;
}

.f-500 {
  font-weight: 500;
}
.dblock {
  display: block !important;
}
.input-color {
  margin-bottom: 10px;
  position: relative;
  display: block;
}
.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}

.form-row {
  padding: 8px;
  color: #1465a3;
  border: 1px dotted #07a7e14f;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.field {
  width: 100%;
  text-transform: capitalize;
  border-bottom: 2px solid #d0d0d0;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  transition: all 0.2s ease-in-out 0.2s;
  -webkit-transition: all 0.2s ease-in-out 0.2s;
  -moz-transition: all 0.2s ease-in-out 0.2s;
}
.sub-frm-title {
  padding: 5px;
  background-color: #fff;
  margin-top: -25px;
  text-align: center;
  color: rgba(7, 167, 225, 0.61);
}
/* overide css of vuesax */
.vs-con-input-label {
  width: 100% !important;
}
.vs-con-input-label.is-label-placeholder {
  margin-top: 8px !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.save-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  float: right;
  margin: 10px 0px;
}
.add-locations-btn {
  box-shadow: none;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
  margin: 10px 0px;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  border-color: rgba(7, 167, 225, 0.61);
  background-color: rgba(7, 167, 225, 0.61);
}

.new-training {
  padding-right: 10px;
}
.title-text {
  margin-bottom: 0px;
}
.selectize-control.multi .selectize-input > div {
  background: rgba(7, 167, 225, 0.61);
  color: #333333;
}
.con-select {
  font-size: 0.85rem !important;
}
.selectize-input.items.not-full.has-options.has-items {
  font-size: 0.85rem !important;
}

/* Floating label css starts */
/****  floating-Lable style start ****/
.floating-label {
  position: relative;
  margin-bottom: 5px;
}
.floating-input,
.floating-select {
  font-size: 14px;
  padding: 4px 30px 4px 5px;
  display: block;
  width: 100%;
  height: 36px;
  box-shadow: none !important;
  /* background-color: transparent; */
  border: none;
  border: 1px solid #ccc;
}

.floating-input:focus,
.floating-select:focus {
  outline: none;
  border: 2px solid rgba(7, 167, 225, 0.61);
}

label.lbl-label {
  color: #ccc;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 6px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

.floating-input:focus ~ label.lbl-label,
.floating-input:not(:placeholder-shown) ~ label.lbl-label {
  background-color: #f9f9f9;
  /* background-color: #fff; */
  top: -12px;
  left: 10px;
  font-size: 14px;
  color: rgba(7, 167, 225, 0.61);
  padding: 0px 5px;
}

.floating-select:focus ~ llabel.lbl-label,
.floating-select:not([value=""]):valid ~ label.lbl-label {
  top: -18px;
  font-size: 14px;
  color: #5264ae;
}

/* active state */
.floating-input:focus ~ .bar:before,
.floating-input:focus ~ .bar:after,
.floating-select:focus ~ .bar:before,
.floating-select:focus ~ .bar:after {
  width: 50%;
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

/* highlighter */
/* .highlight {
  position: absolute;
  height: 50%;
  width: 100%;
  top: 15%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
} */

/* active state */
.floating-input:focus ~ .highlight,
.floating-select:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

/* animation */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.vs-popup--background {
  opacity: 0.3 !important;
}
.con-img-upload .img-upload {
  width: 150px !important;
}
.cont-bdr {
  display: none;
}
@media print {
  .print-btn {
    display: none;
  }
  .cont-bdr {
    display: block;
  }
  .heading {
    display: none;
  }
}
.cont-bdr {
  border-top: 1px solid #ebe9e9;
  border-right: 1px solid #ebe9e9;
}
.col-bdr-bottom {
  border-bottom: 0.5px solid #ebe9e9;
  border-left: 0.5px solid #ebe9e9;
}
</style>


